// extracted by mini-css-extract-plugin
export default {"voteImage":"rYuQpx","mobile":"rwVsya","voteContent":"HQS0m4","voteBackground":"IoRXXL"};